import { Box, Typography, CircularProgress } from '@mui/material'

interface EmptyStateProps {
  conversionInProgress: boolean
}

export function EmptyState({ conversionInProgress }: EmptyStateProps) {
  if (!conversionInProgress) {
    return null
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
      <CircularProgress size={40} sx={{ mb: 2 }} />
      <Typography align="center" color="text.secondary">
        Converting files to DICOM format. Studies and series will appear here when ready.
      </Typography>
    </Box>
  )
}
